module.exports = __webpack_public_path__ + "static/media/dhritiman.52671672.png";